import { Dispatch, SetStateAction } from "react";
import { Input } from "@tellescope/ui";
import { ContactDetailsBlockInfoRegistry, ContactDetailsBlockType } from "../../../types";
import type { useBlock } from "../../../hooks";
import { Button } from "@tellescope/design-system";

export interface BlockTitleProps<T extends ContactDetailsBlockType> {
  canEditTitle: boolean;
  isEditingTitle: boolean;
  setIsEditingTitle: Dispatch<SetStateAction<boolean>>;
  newTitle: string;
  setNewTitle: (title: string) => void;
  parsedInfo: ContactDetailsBlockInfoRegistry[T] | undefined;
  updateInfo: ReturnType<typeof useBlock<T, unknown>>["updateInfo"];
}

export const BlockTitle = <T extends ContactDetailsBlockType>({
  canEditTitle,
  isEditingTitle,
  setIsEditingTitle,
  newTitle,
  setNewTitle,
  parsedInfo,
  updateInfo,
}: BlockTitleProps<T>) => {
  if (!canEditTitle) return <p className="font-semibold text-sm">{newTitle}</p>;

  if (!isEditingTitle) {
    return (
      <Button
        variant="ghost"
        onClick={() => setIsEditingTitle(true)}
        className="font-semibold text-sm text-left grow justify-start"
      >
        {newTitle}
      </Button>
    );
  }

  return (
    <Input
      value={newTitle}
      onChange={(e) => setNewTitle(e.target.value)}
      className="border-none"
      autoFocus
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          updateInfo({ ...parsedInfo, id: parsedInfo?.id ?? crypto.randomUUID(), title: newTitle });
          setIsEditingTitle(false);
        } else if (e.key === "Escape") {
          setIsEditingTitle(false);
        }
      }}
      onBlur={() => setIsEditingTitle(false)}
    />
  );
};
